import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SpxButtonComponent } from "./spx-button.component";

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [SpxButtonComponent],
  exports: [SpxButtonComponent],

})
export class SpxButtonComponentModule { }
